const convertNumberToWord = (number: number, lang: string) => {
  switch (number) {
    case 1:
      return lang === 'en' ? 'First' : 'اول'
    case 2:
      return lang === 'en' ? 'Second' : 'دوم'
    case 3:
      return lang === 'en' ? 'Third' : 'سوم'
    case 4:
      return lang === 'en' ? 'Fourth' : 'چهارم'
    case 5:
      return lang === 'en' ? 'Fifth' : 'پنجم'
    case 6:
      return lang === 'en' ? 'Sixth' : 'ششم'
    case 7:
      return lang === 'en' ? 'Seventh' : 'هفتم'
    case 8:
      return lang === 'en' ? 'Eighth' : 'هشتم'
    case 9:
      return lang === 'en' ? 'Ninth' : 'نهم'
    case 10:
      return lang === 'en' ? 'Tenth' : 'دهم'
    default:
      return 'toooooooooMuch'
  }
}
export default convertNumberToWord
